export const DELETE_ATTACHMENT_TXT = "Are you sure you want to delete this file?";
export const DELETE_MODAL_HEADER = "Delete Attachment";
export const DEFAULT_MODAL_WIDTH = "75%";
export const EMAIL_BTN = "Email";
export const MD_MODAL_HEADER = "Merge and Delete";
export const ADD_AVAILABILITY_MODAL_HEADER = "Availability/Time Off";
export const AVAILABILITY_MODAL_WIDTH = "40%";
export const DISABLE_ROW = "disabled-row";
export const SEND_SMS_MODAL_HEADER = "Send Message";
export const DELETE_CANDIDATE_HOLIDAYS = "Delete Candidate Holidays";
export const CANDIDATE_APPLICATION_MODAL = "Candidate Application";
export const CANDIDATE_IMPORT_MODAL = "Candidate Import";
export const CANDIDATE_IMPORT_2_BTN = "Candidate Import Detailed";
export const CANDIDATE_SELECTION_WARN = "Please select atleast one candidate.";
export const CANDIDATE_DELETE_WARN = "You can select only one candidate at a time";
export const DELETE_PERSON_MODAL_HEADER = "Delete Person";
export const EMAIL_MODAL_HEADER = "Send Email";
export const EMAIL_MODAL_WIDTH = "40%";
export const CENTER = "center";
export const RIGHT = "right";
export const LEFT = "left";
export const NO_TAGS = "No Tags Found";

// Duplicated subset of SITE_TABLE (owned by the site-management step).
export const SITE_TABLE_LABELS = Object.freeze({
  ROW_KEY: "ObjectId"
});

// Duplicated subset of CANDIDATE_AVAILABILITY_MODAL (owned by the shared/ui/candidate step).
export const CANDIDATE_AVAILABILITY_MODAL_LABELS = Object.freeze({
  ADD_TIME_OFF_ITEM: "addTimeOff"
});

export const CANDIDATE_TABLE_LABELS = Object.freeze({
  FORENAME: "Forename",
  FORENAME_KEY: "forename",
  FORENAME_SEARCH_KEY: "forename",
  SURNAME: "Surname",
  SURNAME_KEY: "surname",
  SURNAME_SEARCH_KEY: "surname",
  EMAIL: "Send Email",
  PHONE: "Call",
  ACTION: "Action",
  ROW_KEY: "ObjectId",
  DISABLE: "DoNotUse",
  TAGS_TITLE: "Tags",
  TAGS_KEY: "Tags",
  BRANCHES: "Branches",
  BRANCHES_KEY: "Branches",
  BRANCHES_SEARCH_KEY: "branch"
});

export const CANDIDATE_FILTER_LABELS = Object.freeze({
  DELETE_PERSON_BTN: "Delete",
  ADD_CANDIDATE_BTN: "Add",
  CLIENT_FILTER_PLACEHOLDER: "Client",
  SITE_FILTER_PLACEHOLDER: "Site",
  STATUS_FILTER_PLACEHOLDER: "Status",
  BRANCH_FILTER_PLACEHOLDER: "Branches",
  TAGS_FILTER_PLACEHOLDER: "Tags",
  PROCESSED: "Processed",
  DONOTUSE: "DoNotUse",
  INACTIVE: "Inactive",
  ACTIVE: "Active",
  UNPROCESSED: "Unprocessed"
});

// Duplicated full copy of CTA_MODAL (owned by the upcoming booking step), reused here for the
// candidate calendar's booking CTA icons/status.
export const CTA_MODAL_LABELS = Object.freeze({
  HEADER: {
    DECLINE: "Decline Booking",
    CONFIRM: "Confirm Booking",
    START: "Start Booking",
    BULK_START: "Bulk Start Bookings",
    END: "End Booking",
    BULK_END: "Bulk End Bookings",
    REPEAT: "Assign Candidate To Matching",
    RESET: "Reset Booking",
    CANCEL: "Cancel Booking",
    EDIT: "Edit Booking",
    CONFIRM_CANCEL: "Confirm Cancellation",
    EDIT_BOOKING_DETAILS: "Edit Booking Details",
    CANCEL_MULTIPLE_BOOKINGS: "Cancel Multiple Bookings",
    ADD_BOOKING: "Add Booking"
  },
  STATUS: {
    ST_DECLINE: "Decline",
    ST_CONFIRM: "Confirm",
    ST_START: "Start",
    ST_END: "End",
    ST_REPEAT: "Repeat",
    ST_RESET: "Reset",
    ST_CANCEL: "Cancel",
    ST_SMS: "SMS",
    ST_CHANGE_STIME: "ChangeStartTime",
    ST_CHANGE_SHIFT_LENGTH: "ChangeExpectedShiftLength"
  },
  BOOKING_STATUS: {
    PENDING_ST: "Pending",
    AWAIT_ST: "AwaitingConfirmation",
    CONFIRM_ST: "Confirmed",
    START_ST: "Started",
    COMPLETE_ST: "Complete",
    AWAIT_CANCEL_ST: "AwaitingCancel",
    CANCEL_ST: "Cancelled",
    TOTAL: "Total"
  },
  BUTTON: {
    CANCEL: "CANCEL BOOKING",
    START: "START",
    END: "END",
    CONFIRM: "CONFIRM",
    DECLINE: "DECLINE",
    SUBMIT: "SUBMIT",
    RESET: "RESET",
    EDIT: "EDIT",
    REPEAT: "Repeat"
  }
});
